import * as Sentry from "@sentry/nextjs";

const ENABLE_SENTRY =
  process.env.NEXT_PUBLIC_ENABLE_SENTRY?.toLowerCase() === "true";
const DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (ENABLE_SENTRY && DSN) {
  Sentry.init({
    dsn: DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || "development",
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

    // Disable all performance monitoring
    tracesSampleRate: 0,

    // Disable session replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    // Disable profiling
    profilesSampleRate: 0,

    // Capture console errors and warnings
    integrations: [
      Sentry.captureConsoleIntegration({
        levels: ["error", "warn"], // Only capture errors and warnings
      }),
    ],

    // Only capture errors and messages (not performance data)
    beforeSend(event, hint) {
      // Log in development to debug
      if (process.env.NODE_ENV === "development") {
        console.log("[Sentry beforeSend] Event type:", event.type, "Event:", event);
      }

      // Allow all error and message events
      // Error events have type "error", message events have type "message"
      if (event.type === "error" || event.type === "message") {
        if (process.env.NODE_ENV === "development") {
          console.log("[Sentry beforeSend] ✅ Allowing event:", event.type);
        }
        return event;
      }

      // Filter out transaction events (performance monitoring) and other non-error events
      if (event.type === "transaction") {
        if (process.env.NODE_ENV === "development") {
          console.log("[Sentry beforeSend] ❌ Filtering out transaction");
        }
        return null;
      }

      // Allow any event that has exceptions (errors) - this is a fallback
      if (event.exception && event.exception.values && event.exception.values.length > 0) {
        if (process.env.NODE_ENV === "development") {
          console.log("[Sentry beforeSend] ✅ Allowing event with exceptions");
        }
        return event;
      }

      // Default: allow the event (don't filter it out)
      // This is safer - we only explicitly filter transactions
      if (process.env.NODE_ENV === "development") {
        console.log("[Sentry beforeSend] ⚠️ Allowing unknown event type:", event.type);
      }
      return event;
    },

    // Enable debug mode in development to troubleshoot
    debug: process.env.NODE_ENV === "development",

    // Reduce noise by ignoring common non-critical errors
    // Commented out temporarily to test - uncomment after verifying Sentry works
    // ignoreErrors: [
    //   "ResizeObserver loop limit exceeded",
    //   "Non-Error promise rejection captured",
    //   "ChunkLoadError",
    //   "Loading chunk",
    // ],
  });

  if (process.env.NODE_ENV === "development") {
    console.log("✅ Sentry Client initialized:", {
      enabled: ENABLE_SENTRY,
      hasDsn: !!DSN,
      environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || "development",
    });
  }
} else {
  if (process.env.NODE_ENV === "development") {
    console.warn("⚠️ Sentry Client NOT initialized:", {
      enabled: ENABLE_SENTRY,
      hasDsn: !!DSN,
      reason: !ENABLE_SENTRY ? "ENABLE_SENTRY is not 'true'" : "DSN is missing",
    });
  }
}

// Export router transition hook for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

